var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c("hamburger", {
        staticClass: "hamburger-container",
        attrs: { id: "hamburger-container", "is-active": _vm.sidebar.opened },
        on: { toggleClick: _vm.toggleSideBar },
      }),
      _c("breadcrumb", {
        staticClass: "breadcrumb-container",
        attrs: { id: "breadcrumb-container" },
      }),
      _c(
        "div",
        { staticClass: "right-menu" },
        [
          _vm.device !== "mobile"
            ? [
                _c("search", {
                  staticClass: "right-menu-item",
                  attrs: { id: "header-search", placeholder: "搜索菜单" },
                }),
                _c(
                  "div",
                  {
                    staticClass: "right-menu-item custom-screen",
                    on: { click: _vm.goScreen },
                  },
                  [_vm._v(" 驾驶舱 ")]
                ),
              ]
            : _vm._e(),
          _c(
            "el-dropdown",
            {
              staticClass: "avatar-container right-menu-item hover-effect",
              attrs: { trigger: "click" },
            },
            [
              _c(
                "div",
                { staticClass: "avatar-wrapper" },
                [
                  _c(
                    "el-avatar",
                    { attrs: { fit: "fill", src: _vm.avatar } },
                    [
                      _c("el-avatar", [
                        _vm._v(_vm._s(_vm._f("userAvatarFilter")(_vm.name))),
                      ]),
                    ],
                    1
                  ),
                  _c("span", { staticClass: "user-name" }, [
                    _vm._v(_vm._s(_vm.name)),
                  ]),
                ],
                1
              ),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c("el-dropdown-item", [
                    _c(
                      "span",
                      {
                        staticStyle: { display: "block" },
                        on: { click: _vm.deleteCache },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("navbar.deleteCache")) + " ")]
                    ),
                  ]),
                  _c("el-dropdown-item", { attrs: { divided: "" } }, [
                    _c(
                      "span",
                      {
                        staticStyle: { display: "block" },
                        on: { click: _vm.logout },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("navbar.logOut")) + " ")]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }